import React from "react"
import { StyledIcon } from "../StyledIcon"

const HelpCenterWmoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      d="M7.665 14.8862C11.346 14.8862 14.33 11.9021 14.33 8.22115C14.33 4.54017 11.346 1.55615 7.665 1.55615C3.98402 1.55615 1 4.54017 1 8.22115C1 11.9021 3.98402 14.8862 7.665 14.8862Z"
      stroke="#3E3E47"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.72461 6.2216C5.88131 5.77616 6.19059 5.40055 6.59769 5.16129C7.00479 4.92203 7.48343 4.83458 7.94884 4.9144C8.41424 4.99423 8.83638 5.2362 9.14047 5.59744C9.44457 5.95869 9.61101 6.4159 9.6103 6.8881C9.6103 8.2211 7.6108 8.8876 7.6108 8.8876"
      stroke="#3E3E47"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.66406 11.5537H7.67073"
      stroke="#3E3E47"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default HelpCenterWmoIcon
